import { render, staticRenderFns } from "./RiderPasswordReset.vue?vue&type=template&id=099fcf26"
import script from "./RiderPasswordReset.vue?vue&type=script&lang=js"
export * from "./RiderPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports